module.exports = __webpack_public_path__ + "static/img/icon18.88373ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon18.png
// module id = yrMT
// module chunks = 0